import { render, staticRenderFns } from "./CoolingEfficiencySituationIcon.vue?vue&type=template&id=63325de0&scoped=true&"
import script from "./CoolingEfficiencySituationIcon.vue?vue&type=script&lang=js&"
export * from "./CoolingEfficiencySituationIcon.vue?vue&type=script&lang=js&"
import style0 from "./CoolingEfficiencySituationIcon.vue?vue&type=style&index=0&id=63325de0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63325de0",
  null
  
)

export default component.exports